import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, MenuItem } from '@mui/material';

const StrategyMultiInputDialog = ({ open, onClose, onSubmit }) => {
  
  const formatDate = (date) => { 
    let day = date.getDate();
    let month = date.getMonth() + 1; // Months start from 0
    let year = date.getFullYear();
    
    // Ensuring two digits for day and month
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;
    //console.log(`${year}-${month}-${day}`)
    return `${year}-${month}-${day}`;
  }

  const currentDate = new Date();
  const formattedCurrentDate = formatDate(currentDate);
  
  const [inputs, setInputs] = useState({
    goaltext: '',
    validfrom: formattedCurrentDate,
    validto: '2050-01-01',
    sdg: 0,
    access:0
  });

  const cleanFormData = () => {
    inputs.goaltext = '';
    inputs.validfrom = formattedCurrentDate;
    inputs.validto = '2050-01-01';
    inputs.sdg = 0
    inputs.access = 0
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (inputs.goaltext && inputs.validfrom && inputs.validto) {
      onSubmit(inputs);
      onClose(); // Close dialog after submission
    } else {
      alert('Please fill all required fields.');
    }
  };

  useEffect(() => {
    if (open) {
        cleanFormData();
      } 
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}
      PaperProps={{ style: { backgroundColor: '#231E39'}}}
    >
      <DialogTitle style={{color: 'white'}}>Insert data for new strategy</DialogTitle>
      <DialogContent style={{color: 'white'}}>
        <TextField 
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}     
        autoFocus margin="dense" name="goaltext" label="Strategy Name" fullWidth variant="standard" value={inputs.goaltext} onChange={handleChange} />
        <TextField 
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}  
        margin="dense" name="validfrom" label="Valid From" fullWidth variant="standard" type="date" value={inputs.validfrom} onChange={handleChange} />
        <TextField 
                      sx={{
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}  
        margin="dense" name="validto" label="Valid To" fullWidth variant="standard" type="date" value={inputs.validto} onChange={handleChange} />
        <TextField 
                      sx={{
                        '& .MuiInputBase-root': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}        
        margin="dense" name="sdg" label="SDG (Optional)" fullWidth variant="standard" value={inputs.sdg} onChange={handleChange} select>
          <MenuItem value={0}>Unknown</MenuItem>
                        <MenuItem value={1}>SDG1 - No poverty</MenuItem>
                        <MenuItem value={2}>SDG2 - Zero Hunger</MenuItem>
                        <MenuItem value={3}>SDG3 - Good Health and well-being</MenuItem>
                        <MenuItem value={4}>SDG4 - Quality Education</MenuItem>
                        <MenuItem value={5}>SDG5 - Gender Equality</MenuItem>
                        <MenuItem value={6}>SDG6 - Clean Water and Sanitation</MenuItem>
                        <MenuItem value={7}>SDG7 - Affordable and Clean Energy</MenuItem>
                        <MenuItem value={8}>SDG8 - Decent work and Economic Growth</MenuItem>
                        <MenuItem value={9}>SDG9 - Industry, Innovation and infrastructre</MenuItem>
                        <MenuItem value={10}>SDG10 - Reduce Inequalities</MenuItem>
                        <MenuItem value={11}>SDG11 - Sustainable Cities and communities</MenuItem>
                        <MenuItem value={12}>SDG12 - Responsible Consumption and Production</MenuItem>
                        <MenuItem value={13}>SDG13 - Climate Action</MenuItem>
                        <MenuItem value={14}>SDG14 - Life Below Water</MenuItem>
                        <MenuItem value={15}>SDG15 - Line On Land</MenuItem>
                        <MenuItem value={17}>SDG16 - Peace, justice and strong institutions</MenuItem>
                        <MenuItem value={17}>SDG17 - Partnerships for the goals</MenuItem>
          </TextField> 
        <TextField 
                      sx={{
                        '& .MuiInputBase-root': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInput-input': { backgroundColor: 'PowderBlue' , color: 'black', opacity: '65%' },
                        '& .MuiInputLabel-root': { color: 'white' },
                      }}        
        margin="dense" name="access" label="Public/Private" fullWidth variant="standard" value={inputs.access} onChange={handleChange} select>
                      <MenuItem value={0}>Public</MenuItem>
                      <MenuItem value={1}>Private</MenuItem>
                    </TextField>
      </DialogContent>
      <DialogActions
          sx={{'& .MuiButton-text' : {color: 'var(--main-color)'}}}
      >
        <Button onClick={onClose}
        sx={{
          paddingRight: '1.5rem',
          marginRight: '1.5rem',
          border: '1px solid var(--main-color)',
          
        }}>Cancel</Button>
        <Button onClick={handleSubmit}
        sx={{
          paddingRight: '1.5rem',
          marginRight: '1.5rem',
          border: '1px solid var(--main-color)',
          
        }}>Submit</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StrategyMultiInputDialog